/* eslint-disable import/extensions */
import React from 'react'
import { useSelector } from 'react-redux'

import { Form, Formik } from 'formik'

import { Box, Typography, Collapse, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import signUpSchema from './SignUpForm.schemas'
import useSignUpForm from './useSignUpForm'

import { SignUpFormProps } from '../../model/line.model'
import { selectLineValues } from '../../store/line.selectors'
import DonorOwner from '../DonorOwner/DonorOwner'
import ICCField from '../ICCField/ICCField'
import SignUpType from '../SignUpType/SignUpType'

import { selectIsOffline } from '~/agent/store/agent.selectors'
import { RootState } from '~/core/store/root.reducer'
import { selectDocId } from '~/customer/store/customer.selectors'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiFormControl-root': {
      width: '100%',
    },
    "& [role='radiogroup']": {
      flexDirection: 'row',
    },
    '& .greyWrapper': {
      backgroundColor: theme.palette.grey[100],
    },
  },
}))

function SignUp({ hasSelectedTariff, id }: SignUpFormProps) {
  const { isPrepaid, isPortability, isNewProduct, isOffline } = useSignUpForm(id)

  return (
    <Form data-hook={`sign-up-type-form-${id}`}>
      <SignUpType id={id} hasSelectedTariff={hasSelectedTariff} />
      <Collapse in={isPortability || (isNewProduct && isOffline)}>
        <Box px={6} py={8} className="greyWrapper">
          {isOffline && <ICCField id={id} />}
          <Collapse in={isPrepaid}>
            <ICCField id={id} isDonorIcc />
          </Collapse>
          <Collapse in={isPortability}>
            <DonorOwner id={id} />
          </Collapse>
        </Box>
      </Collapse>
    </Form>
  )
}

export default function SignUpForm({
  hasSelectedTariff,
  id,
}: {
  hasSelectedTariff: boolean
  id: string
}) {
  const { root } = useStyles()
  const initialValues = useSelector((state: RootState) => selectLineValues(state, id))
  const customerDoc = useSelector(selectDocId)
  const isOffline = useSelector(selectIsOffline)

  return (
    <Box className={root}>
      <Box px={6}>
        <Typography variant="subtitle2"> DATOS DE LA LÍNEA</Typography>
      </Box>
      <Box mt={4}>
        <Formik
          onSubmit={(values, formik) => {
            formik.setSubmitting(false)
          }}
          initialValues={initialValues.signUp}
          validationSchema={signUpSchema(customerDoc, isOffline)}
          initialStatus={{}}
          validateOnMount
        >
          <SignUp id={id} hasSelectedTariff={hasSelectedTariff} />
        </Formik>
      </Box>
    </Box>
  )
}
